const animateList = document.querySelectorAll('.__animate__animated');

const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.className = entry.target.className.replace(/__animate__/g, 'animate__');
            observer.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.3
});

animateList.forEach(animateEl => observer.observe(animateEl));